import styled from 'styled-components';

export const Heading = styled.h2`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 2.5rem;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  font-weight: ${({ theme }) => theme.typography.fontWeights.semibold};
  line-height: 1.2;
  max-width: 800px;
  margin-top: 0px;

  em {
    font-style: italic;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1.5rem;
  }
`;
